import { render, staticRenderFns } from "./LightNav.vue?vue&type=template&id=49d0769b"
import script from "./LightNav.vue?vue&type=script&lang=js"
export * from "./LightNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports